module.exports = __webpack_public_path__ + "static/media/ic-arrow-dw.2bc96145.svg";